var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcymi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "100px",
    viewBox: "0 0 200 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2.0 Images / Logos / Rounds / ICYMI@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.0-Images-/-Logos-/-Rounds-/-ICYMI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(12.388488, 9.388488)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5537025,30.4224853 L23.8472582,41.4796519 L29.5526895,41.4796519 L31.1998758,30.4224853 L25.5537025,30.4224853 Z M39.9043158,30.4224853 L38.1987974,41.4796519 L43.2570205,41.4796519 L43.2570205,48.6554215 L37.0812292,48.6554215 L35.4349687,59.4774079 L26.7888608,59.4774079 L28.4351212,48.6554215 L22.788948,48.6554215 L21.0834296,59.4774079 L12.4373216,59.4774079 L14.1437659,48.6554215 L9.02628483,48.6554215 L9.02628483,41.4796519 L15.2011503,41.4796519 L16.9075946,30.4224853 L11.7910394,30.4224853 L11.7910394,23.2467158 L17.9668308,23.2467158 L19.6130912,12.4247293 L28.3175312,12.4247293 L26.6129387,23.2467158 L32.3174441,23.2467158 L33.9637045,12.4247293 L42.6098124,12.4247293 L40.963552,23.2467158 L46.0801072,23.2467158 L46.0801072,30.4224853 L39.9043158,30.4224853 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "50.1409446 59.4777783 59.5518507 59.4777783 59.5518507 12.4250997 50.1409446 12.4250997"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1964173,60.0654506 C68.9622938,60.0654506 63.8448127,55.5951777 63.8448127,50.8313926 L63.8448127,21.0709298 C63.8448127,16.3062188 68.9622938,11.8368717 75.1964173,11.8368717 C81.4305407,11.8368717 86.3711738,16.3062188 86.3711738,21.0709298 L86.3711738,30.4225779 L77.0204516,30.4225779 L77.0204516,21.3061099 C77.0204516,20.4829797 76.1963955,19.8941036 75.1964173,19.8941036 C74.197365,19.8941036 73.3733089,20.4829797 73.3733089,21.3061099 L73.3733089,50.5962125 C73.3733089,51.4193427 74.197365,52.0072929 75.1964173,52.0072929 C76.1963955,52.0072929 77.0204516,51.4193427 77.0204516,50.5962125 L77.0204516,41.4797445 L86.3711738,41.4797445 L86.3711738,50.8313926 C86.3711738,55.5951777 81.4305407,60.0654506 75.1964173,60.0654506",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "105.370575 39.1859981 105.370575 59.4772227 96.2531808 59.4772227 96.2531808 39.1859981 88.7246411 12.4245441 97.724445 12.4245441 101.31233 28.1288316 104.546519 12.4245441 113.192627 12.4245441"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "141.425808 59.4772227 141.425808 29.539912 135.544454 59.4772227 129.369589 59.4772227 124.07526 29.4815799 124.07526 59.4772227 115.606 59.4772227 115.606 12.4245441 129.956613 12.4245441 133.426908 33.8925949 137.132383 12.4245441 150.836714 12.4245441 150.836714 59.4772227"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "155.484946 59.4777783 164.895852 59.4777783 164.895852 12.4250997 155.484946 12.4250997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-11",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0 70.8512342 75.1085488 70.853086 87.9027145 82.2222827 100.008932 70.8512342 175.803577 70.8512342 175.803577 -5.68434189e-14 0 -5.68434189e-14"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcymi);
export default __webpack_public_path__ + "static/media/icymi.c4650483.svg";
export { ForwardRef as ReactComponent };